/**
 * Suppliers Reducers Index
 * Combines all supplier-related reducers
 */

import { combineReducers } from 'redux';
import suppliersListReducer from './suppliersList';
import currentSupplierReducer from './currentSupplier';

const suppliersReducers = combineReducers({
  suppliersList: suppliersListReducer,
  currentSupplier: currentSupplierReducer
});

export default suppliersReducers;